import Scheme from "store/schema";

export const getOptionalBlocks = (schema: Scheme) => {

  const arr = []

  for (let [ blockId, block ] of Object.entries(schema.data.blocks)) {
    if (block.data.required !== "false") continue

    const name = [ ...findParentPath(schema, blockId), block.data.name ].join(" > ")
    
    arr.push([ blockId, name ])
  }
  return arr
}

const findParentPath = (schema: Scheme, blockId: string): string[] => {
  const parentId = schema.data.chains.find(chain => chain.to === blockId)?.from[0]
  const parent = parentId && schema.data.blocks[parentId]
  if (!parent) return []

  if (parent.type === "array" || parent.type === "group") return [ ...findParentPath(schema, parentId), parent.data.name ]
  
  return findParentPath(schema, parentId)
}